var addThisButtons = function(){
  var addthisScript = document.createElement('script');
  addthisScript.setAttribute('src', 'http://s7.addthis.com/js/300/addthis_widget.js#domready=1');
  document.body.appendChild(addthisScript);
};

var navbar_scroll = function(){
  var navbar = $('#navbar-top-scroll');
  var navbar_visible = navbar.length !== 0;

  if($(window).scrollTop()>=270){
    if (!navbar.length){
      navbar = $('.navbar-top').clone();
      navbar.attr('id','navbar-top-scroll')
      .addClass('navbar-top-scroll')
      .prependTo('body');
      navbar.find('#menu').attr('id','');
    }else if(navbar.hasClass('hide')){
      navbar.removeClass('hide');
    }
  }else if($(window).scrollTop()<270){
    if(!navbar.hasClass('hide')){
      navbar.addClass('hide');
    }
  }
};

var bLazy = new Blazy({});

function homeSliders(){
  var news_spotlights;
  var home_spotlights;

  function getMarginSize() {
    return (window.innerWidth < 690) ? 0 : (window.innerWidth > 1100) ? 45 : 30;
  }

  function getMobileSlider() {
    return (window.innerWidth < 690) ? false : true;
  }

  function getHomeItems(){
    return (window.innerWidth < 690) ? 1 : 3;
  }

  $(window).bind('load',function() {
    news_spotlights = $('.news-spotlights').flexslider({
      animation: "slide",
      itemWidth: 210,
      itemMargin: getMarginSize(),
      directionNav: false,
      minItems: 3,
      maxItems: 3,
      start:function(){
        if(!getMobileSlider()){
          news_spotlights.flexslider('pause');
        }
        bLazy.revalidate();
      },
      after:function(){
        bLazy.revalidate();
      }
    });

    home_spotlights = $('.home-spotlights').flexslider({
      animation: "slide",
      itemWidth: 210,
      itemMargin: getMarginSize(),
      slideshow: false,
      directionNav: false,
      minItems: getHomeItems(),
      maxItems: getHomeItems(),
    });


  });

  $(window).bind('resize',function(){
    news_spotlights.flexslider('pause');
    news_spotlights.data('flexslider').vars.itemMargin = getMarginSize();
    home_spotlights.data('flexslider').vars.itemMargin = getMarginSize();

    if(!getMobileSlider()){
      home_spotlights.data('flexslider').vars.minItems = getHomeItems();
      home_spotlights.data('flexslider').vars.maxItems = getHomeItems();
    }else{
      home_spotlights.data('flexslider').vars.minItems = 3;
      home_spotlights.data('flexslider').vars.maxItems = 3;
    }
  });
}

function open_search(verb, url, data, target) {
  var form = document.createElement("form");
  form.action = url;
  form.method = verb;
  form.target = target || "_self";
  if (data) {
    $.each(data, function(key,data) {
      var input = document.createElement("input");
      input.type = 'hidden';
      input.name = data.key;
      input.value = data.value;
      form.appendChild(input);
    });
  }
  form.style.display = 'none';
  document.body.appendChild(form);
  form.submit();
  form.remove();
}

(function() {

  if($('.page-home').length > 0){
    homeSliders();
  }

  $(window).bind('load',addThisButtons);

  $(document).on('submit','.header-box-search,.navs-container',function(e){
    e.preventDefault();
    var input = $(this).find('[type=text]');
    var search = input.val();
    if (search!=='') {
      search = search;

      var data = [
        {key: 'Database', value: '10170_GERAL'},
        {key: 'SearchText', value: search},

      ];

      open_search('GET', 'http://biblioteca.cm-tvedras.pt/Opac/Pages/Search/Results.aspx', data, '_blank');
    }
    else {
      open_search('GET', 'http://biblioteca.cm-tvedras.pt/Opac/Pages/Search/SimpleSearch.aspx', '', '_blank');
    }
    input.val('');

  });

  $(document).on('click','[data-toggle=gallery-modal]',function(e){
    e.preventDefault();
    var src = $(this).attr('href');
    var icon = $('<i></i>').addClass('icon-close');
    var button = $('<button></button>')
    .addClass('btn')
    .addClass('gallery-modal-close')
    .append(icon);
    var image = $('<img />').hide();

    var img_load = new Image();
    img_load.onload = function() {
      image.attr('src',src).fadeIn(500);
    };

    img_load.src = src;

    modal = $('<div></div>')
    .hide()
    .addClass('gallery-modal')
    .append(button)
    .append(image)
    .appendTo('body')
    .fadeIn(500);

    button.on('click',function(){
      modal.fadeOut(500,function(){
        $(this).remove();
      });
    });
  });

  $('.scroll').jscroll({
    nextSelector:'.jscroll-next-page',
    autoTrigger:false,
    loadingHtml:'<div class="loader"></div>',
    callback:function(){
      $('.jscroll-added:last').hide().fadeIn(500);

      bLazy.revalidate();

      var partners = $('.jscroll-added:last').find('.partner-description');

      if(partners.length > 0)
      {
        partners.css({'max-height':'370px','overflow':'hidden'}).dotdotdot({
          watch:true,
          height:370,
          ellipsis	: '...',
          callback: dotdotdotCallback
        });
      }


    }
  });

  $(window).bind('scroll',navbar_scroll);

  $.scrollUp({
    scrollText: '<i class="icon-up"></i>',
    zIndex: 1030
  });

  $('input, textarea').placeholder();

  $('.nav-menu-container').perfectScrollbar();



$('.partner-description').css({'max-height':'370px','overflow':'hidden'}).dotdotdot({
  watch:true,
  height:370,
  ellipsis	: '...',
  callback: dotdotdotCallback
});

function dotdotdotCallback(isTruncated, originalContent) {
  if (isTruncated) {
    $('<a class="more" href="#"><i class="icon-more"></i></a>').appendTo(this);
    $(this).css('max-height','none');
  }
}

$(document).on('click','.partner-description .more',function(e) {
  e.preventDefault();
  var div = $(this).closest('.partner-description');

  div.trigger('destroy');

  $(this).remove();

  $('<a class="less" href="#"><i class="icon-less"></i></a>').appendTo(div.children());
  div.animate({'max-height':div.children().height()+'px'});
});

$(document).on('click','.partner-description .less',function(e) {
  e.preventDefault();
  var div = $(this).closest('.partner-description');
  $(this).remove();
  $('.more', this).show();
  div.animate({'max-height':'405px'},400,'swing',function(){
    $(this).dotdotdot({
      watch:true,
      height:370,
      ellipsis	: '...',
      callback: dotdotdotCallback
    });
  });
});

}());



// WEBPACK FOOTER //
// ./resources/assets/js/main.js